import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('interazioniEmail');
export const actions = helper.createActions('interazioniEmail', actionTypes);